import RemarksB from './RemarksB';

export default RemarksB;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/FluidData/RemarksB/index.tsx